<template>
  <container-slot>
    <v-col cols="12" md="4" v-show="breakpoints.mdAndUp"> </v-col>
    <v-col cols="12" md="4">
      <v-text-field
        append-icon="mdi-magnify"
        class="mt-5"
        color="#6fbee2"
        label="Search Role"
        solo
        v-model="keyword"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="4" v-show="breakpoints.mdAndUp"> </v-col>

    <v-col cols="12" md="1" v-if="removeClicked && breakpoints.mdAndUp">
    </v-col>
    <v-col cols="12" md="10" v-if="removeClicked">
      <v-alert
        :type="!error ? `success` : `error`"
        ref="alert"
        dismissible
        @input="defaultAlert"
        class="noMarg"
        v-show="removeClicked"
      >
        {{ msg }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="1" v-if="removeClicked && breakpoints.mdAndUp">
    </v-col>

    <v-col cols="12" md="1" v-if="breakpoints.mdAndUp"> </v-col>
    <v-col cols="12" md="10">
      <v-card color="#6fbee2" elevation="5">
        <v-card-text>
          <v-data-table
            class="elevation-1 my-auto"
            light
            loading-text="Retrieving data... Please wait"
            :headers="headerRoles"
            :items="filterRoles"
            :items-per-page="5"
            :loading="$apollo.loading"
            :search="keyword"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ fDate(item.createdAt) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <td>
                <v-btn
                  color="blue-grey"
                  class="white--text"
                  @click="$router.push(`/role/edit/${item.id}`)"
                >
                  Edit
                  <v-icon right dark>mdi-square-edit-outline</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn
                  color="error"
                  class="white--text"
                  @click="removeRow(item.id)"
                  v-if="!isAdminRole(item.id)"
                >
                  Remove
                  <v-icon right dark>mdi-trash-can</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="1" v-show="breakpoints.mdAndUp"> </v-col>
  </container-slot>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
import { roles } from "@/utils/graphqlQuery";
import { editRole } from "@/utils/graphqlMutation";
import moment from "moment";

export default {
  apollo: {
    roles: {
      query: roles,
      update: ({ roles }) => {
        roles.sort(function (a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        return roles.map((eachRoles, i) => ({
          no: i + 1,
          ...eachRoles,
        }));
      },
    },
  },
  components: {
    ContainerSlot,
  },
  computed: {
    breakpoints() {
      return {
        mdAndUp: this.$vuetify.breakpoint.mdAndUp,
        smAndDown: this.$vuetify.breakpoint.smAndDown,
      };
    },
    filterRoles() {
      return this.roles.filter((item) => item.roleName.includes(this.keyword));
    },
  },
  data() {
    return {
      error: false,
      keyword: "",
      msg: "",
      removeClicked: false,
      roles: [],
      headerRoles: [
        { text: "No", field: "no", value: "no" },
        { text: "Role Name", field: "roleName", value: "roleName" },
        { text: "Created At", field: "createdAt", value: "createdAt" },
        { text: "Actions", field: "actions", value: "actions" },
      ],
    };
  },
  name: "ListRole",
  methods: {
    async removeRow(id) {
      const that = this;
      this.defaultAlert();
      const permission = confirm("Are you sure want to remove this role ?");
      if (permission) {
        const roleObj = {
          id,
          isDeleted: 1,
        };
        const gqlRoles = roles;
        try {
          const { data } = await this.$apollo.mutate({
            mutation: editRole,
            variables: {
              roleObj,
            },
            update: (store) => {
              const { roles } = store.readQuery({
                query: gqlRoles,
              });
              const uRoles = roles.filter((item) => item.id != id);
              store.writeQuery({
                query: gqlRoles,
                data: {
                  roles: uRoles,
                },
              });
              that.roles = uRoles;
            },
          });
          const { success, msg } = data.editRole;
          if (!success) {
            throw new Error(msg);
          }
          this.error = false;
          this.msg = msg;
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.removeClicked = true;
        }
      }
    },
    defaultAlert() {
      this.removeClicked = false;
      this.error = false;
      this.msg = "";
    },
    fDate(dateStr) {
      return moment(new Date(dateStr)).format("DD/MM/YYYY HH:mm:ss");
    },
    isAdminRole: (identifier) =>
      identifier == 10 || identifier.toLowerCase().includes("admin"),
  },
  title() {
    return "List Role";
  },
};
</script>
<style scoped></style>
